package com.macrofocus.eflux.ui.data

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.ui.data.risk.*
import mui.material.Chip
import mui.material.ChipVariant
import mui.material.Size
import mui.material.Tooltip
import mui.system.sx
import react.*
import web.cssom.FontFamily
import web.cssom.FontSize

external interface RiskTypeChipProps : Props {
    var dataLoader: DataLoader
    var riskType: String?
}

val RiskTypeChip = FC<RiskTypeChipProps> { props ->
    val riskType = props.riskType
    if(riskType != null) {
        Tooltip {
            title = ReactNode(riskType)

            Chip {
                sx {
                    fontFamily = "'JetBrains Mono', monospace".unsafeCast<FontFamily>()
                    fontSize = FontSize.small
                }

                if(riskType == "temperature") {
                    icon = Fragment.create { TemperatureIcon {} }
                } else if(riskType == "wind_gusts") {
                    icon = Fragment.create { WindGustsIcon {} }
                } else if(riskType == "mudslide") {
                    icon = Fragment.create { MudslideIcon {} }
                } else if(riskType == "flooding") {
                    icon = Fragment.create { FloodingIcon {} }
                } else if(riskType == "lightning_expected") {
                    icon = Fragment.create { LightningExpectedIcon {} }
                } else if(riskType == "lightning_activity") {
                    icon = Fragment.create { LightningActivityIcon {} }
                } else if(riskType == "lightning_hit") {
                    icon = Fragment.create { LightningHitIcon {} }
                }

                variant = ChipVariant.outlined
                size = Size.small
                label = ReactNode(riskType)
            }
        }
    }
}